import { render } from "./HeaderPages.vue?vue&type=template&id=7a806f2c&scoped=true"
import script from "./HeaderPages.vue?vue&type=script&lang=js"
export * from "./HeaderPages.vue?vue&type=script&lang=js"

import "./HeaderPages.vue?vue&type=style&index=0&id=7a806f2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a806f2c"]])

export default __exports__